import { useMemo } from "react";
import { useIntl } from "react-intl";
import format from "date-fns/format";
import messages from "./messages";

const useTranslations = (params: {
  customerName: string;
  appointmentDate: string;
  locationCity: string;
  studyNames: string[];
}) => {
  const { customerName, appointmentDate, locationCity, studyNames } = params;
  const { formatMessage } = useIntl();

  const result = useMemo(() => {
    const formattedDate = format(new Date(appointmentDate), "MM/dd/yyyy");
    const studyNamesText = studyNames.join(", ");

    const sectionTitleMap: Record<string, string> = {
      summary: formatMessage(messages.sectionSummary),
      findings: formatMessage(messages.sectionFindings),
      nextSteps: formatMessage(messages.sectionNextSteps),
    };

    const translations = {
      title: formatMessage(messages.title, { customerName }),
      subtitle: formatMessage(messages.subtitle, {
        date: formattedDate,
        locationCity,
        studyNames: studyNamesText,
      }),
      btnClose: formatMessage(messages.btnClose),
      getSectionTitle: (key: string) => sectionTitleMap[key] || key,
    };

    return { translations };
  }, [formatMessage, customerName, appointmentDate, locationCity, studyNames]);
  return result;
};
export default useTranslations;
